import { gql } from '@apollo/client';

export default gql`
  query planSubscriptions {
    planSubscriptions {
      id
      name
    }
  }
`;
